
/* Sticker Social decal engine: order item -> flattened SVG */
(function () {
  const MM = 72 / 25.4;
  const SPEC = {
    boxW: 235 * MM, boxH: 40 * MM,      // reference area including Standard Decal clearances
    marginL: 2.5 * MM, marginR: 2.5 * MM,
    gap: 2 * MM,                       // icon -> text gap
    vClear: 5 * MM,                    // space above and below visible Standard artwork
    textH: 30 * MM,                    // maximum visible Standard artwork height
    cutStroke: 0.25,                    // pt, hairline
    sizes: { S: 0.8, M: 1, L: 1.2 },  // retained for designs placed before stepped sizing
  };

  const FONTS = [
    { n: 1, name: 'Bebas Neue', group: 'Display', file: 'BebasNeue-Regular.ttf' },
    { n: 2, name: 'Fredoka One', group: 'Display', file: 'FredokaOne-Regular.ttf' },
    { n: 3, name: 'Creepster', group: 'Display', file: 'Creepster-Regular.ttf' },
    { n: 4, name: 'Shrikhand', group: 'Display', file: 'Shrikhand-Regular.ttf' },
    { n: 5, name: 'Chewy', group: 'Display', file: 'Chewy-Regular.ttf' },
    { n: 6, name: 'The Bold Font Bold', group: 'Display', file: 'theboldfont.ttf' },
    { n: 7, name: 'Freshman', group: 'Display', file: 'Freshman.ttf' },
    { n: 8, name: 'Shlop', group: 'Display', file: 'shlop rg.ttf' },
    { n: 9, name: 'Thinking of Betty', group: 'Display', file: 'Thinking_of_Betty.ttf' },
    { n: 10, name: 'Rajdhani Bold', group: 'Display', file: 'Rajdhani-Bold.ttf' },
    { n: 11, name: 'Happy Time', group: 'Display', file: 'HappyTime.ttf' },
    { n: 12, name: 'Geizer', group: 'Display', file: 'Geizer.ttf' },
    { n: 13, name: 'Roboto Bold', group: 'Sans Serif', file: 'Roboto-Bold.ttf' },
    { n: 14, name: 'Teko Bold', group: 'Sans Serif', file: 'Teko-Bold.ttf' },
    { n: 15, name: 'Stop Bullying', group: 'Handwriting', file: 'Stop Bullying.ttf' },
    { n: 16, name: 'Love Medium', group: 'Handwriting', file: 'Love.ttf' },
    { n: 17, name: 'Bree Serif', group: 'Serif', file: 'BreeSerif-Regular.ttf' },
    { n: 18, name: 'Vollkorn Bold', group: 'Serif', file: 'Vollkorn-Bold.ttf' },
    { n: 19, name: 'VT323', group: 'Monospace', file: 'VT323-Regular.ttf' },
    { n: 20, name: 'PT Mono', group: 'Monospace', file: 'PTMono-Regular.ttf' },
  ];

  const PLATFORMS = [
    { key: 'INSTAGRAM', label: 'Instagram', count: 3 },
    { key: 'TIKTOK', label: 'TikTok', count: 3 },
    { key: 'YOUTUBE', label: 'YouTube', count: 4 },
    { key: 'FACEBOOK', label: 'Facebook', count: 3 },
    { key: 'SNAPCHAT', label: 'Snapchat', count: 4 },
    { key: 'TWITCH', label: 'Twitch', count: 2 },
  ];

  const fontCache = {};
  let freshmanUnderscoreFont = null;
  function b64ToBuf(b64) {
    const bin = atob(b64); const u = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
    return u.buffer;
  }
  function getFont(n) {
    if (fontCache[n]) return fontCache[n];
    const f = FONTS.find(x => x.n === +n);
    if (f && f.file && window.SS_FONTS[f.file]) {
      fontCache[n] = opentype.parse(b64ToBuf(window.SS_FONTS[f.file]));
      return fontCache[n];
    }
    return null;
  }
  function registerFont(n, buf) { fontCache[n] = opentype.parse(buf); return fontCache[n]; }
  function fontForText(number, text) {
    const font = getFont(number);
    if (Number(number) !== 7 || !String(text).includes('_') || !font || font.charToGlyphIndex('_') !== 0) return font;
    if (!window.SS_FRESHMAN_UNDERSCORE_FONT) return null;
    if (!freshmanUnderscoreFont) freshmanUnderscoreFont = opentype.parse(b64ToBuf(window.SS_FRESHMAN_UNDERSCORE_FONT));
    return freshmanUnderscoreFont;
  }
  function bettyCapitalSpacingPercent(item, text) {
    return Number(item.font) === 9 && /[A-Z]{2}/.test(text) ? Math.max(0, Number(item.spacingStep ?? 0)) * 20 : 0;
  }
  function textCommands(font, text, options, capitalSpacingPercent) {
    if (!capitalSpacingPercent) return cmdsFromOT(font.getPath(text, 0, 0, 100, options));
    const characters = [...text];
    if (font.stringToGlyphs(text, { ...font.defaultRenderOptions, ...options }).length !== characters.length)
      throw new Error('This font cannot use capital spacing. Choose another font.');
    const commands = [];
    let index = 0, offset = 0;
    font.forEachGlyph(text, 0, 0, 100, options, (glyph, x, y, size, renderOptions) => {
      const previous = characters[index - 1], current = characters[index], next = characters[index + 1];
      if (index > 0 && /^[A-Z]$/.test(current) &&
          (/^[A-Z]$/.test(previous) || (/^[a-z]$/.test(previous) && /^[A-Z]$/.test(next)))) offset += capitalSpacingPercent;
      commands.push(...cmdsFromOT(glyph.getPath(x + offset, y, size, renderOptions, font)));
      index++;
    });
    return commands;
  }

  // ---- geometry helpers: commands are [['M',x,y],['L',x,y],['C',x1,y1,x2,y2,x,y],['Z']] in y-down space
  function cmdsFromOT(path) {
    const out = [];
    let cx = 0, cy = 0;
    for (const c of path.commands) {
      if (c.type === 'M') { out.push(['M', c.x, c.y]); cx = c.x; cy = c.y; }
      else if (c.type === 'L') { out.push(['L', c.x, c.y]); cx = c.x; cy = c.y; }
      else if (c.type === 'C') { out.push(['C', c.x1, c.y1, c.x2, c.y2, c.x, c.y]); cx = c.x; cy = c.y; }
      else if (c.type === 'Q') {
        out.push(['C', cx + 2 / 3 * (c.x1 - cx), cy + 2 / 3 * (c.y1 - cy), c.x + 2 / 3 * (c.x1 - c.x), c.y + 2 / 3 * (c.y1 - c.y), c.x, c.y]);
        cx = c.x; cy = c.y;
      } else if (c.type === 'Z') out.push(['Z']);
    }
    return out;
  }
  function bbox(cmds) {
    // exact bbox incl. cubic extrema
    let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity, px = 0, py = 0;
    const add = (x, y) => { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; };
    const ext = (p0, p1, p2, p3) => {
      const a = -p0 + 3 * p1 - 3 * p2 + p3, b = 2 * (p0 - 2 * p1 + p2), c = p1 - p0, ts = [];
      if (Math.abs(a) < 1e-12) { if (Math.abs(b) > 1e-12) ts.push(-c / b); }
      else { const d = b * b - 4 * a * c; if (d >= 0) { const s = Math.sqrt(d); ts.push((-b + s) / (2 * a), (-b - s) / (2 * a)); } }
      return ts.filter(t => t > 0 && t < 1);
    };
    const at = (p0, p1, p2, p3, t) => { const m = 1 - t; return m * m * m * p0 + 3 * m * m * t * p1 + 3 * m * t * t * p2 + t * t * t * p3; };
    for (const c of cmds) {
      if (c[0] === 'M' || c[0] === 'L') { add(c[1], c[2]); px = c[1]; py = c[2]; }
      else if (c[0] === 'C') {
        add(c[5], c[6]);
        for (const t of ext(px, c[1], c[3], c[5])) add(at(px, c[1], c[3], c[5], t), at(py, c[2], c[4], c[6], t));
        for (const t of ext(py, c[2], c[4], c[6])) add(at(px, c[1], c[3], c[5], t), at(py, c[2], c[4], c[6], t));
        px = c[5]; py = c[6];
      }
    }
    return { x0, y0, x1, y1, w: x1 - x0, h: y1 - y0 };
  }
  function transform(cmds, s, sx, tx, ty) { // scale (s vertical, sx horizontal), then translate
    return cmds.map(c => {
      if (c[0] === 'Z') return c;
      const o = [c[0]];
      for (let i = 1; i < c.length; i += 2) o.push(c[i] * sx + tx, c[i + 1] * s + ty);
      return o;
    });
  }
  const f2 = v => (Math.round(v * 1000) / 1000).toString();
  function toD(cmds) {
    return cmds.map(c => c[0] === 'Z' ? 'Z' : c[0] + c.slice(1).map(f2).join(' ')).join('');
  }

  // Merge overlapping shapes (touching letters, script fonts) so the cutter gets one clean outline.
  let paperReady = false;
  function unite(d) {
    if (!window.paper) throw new Error('Path merging is unavailable. Reload the app.');
    try {
      if (!paperReady) { paper.setup(new paper.Size(10, 10)); paperReady = true; }
      const cp = new paper.CompoundPath({ pathData: d, insert: false });
      // Paper's boolean operation requires each operand to have no overlapping
      // subpaths. Build separate filled shapes, retaining nested letter holes,
      // then union those shapes one at a time.
      const nodes = cp.children.map(path => ({ path, area: Math.abs(path.area), sign: path.clockwise ? 1 : -1 }))
        .filter(node => node.area > 1e-9).sort((a, b) => b.area - a.area);
      const roots = [];
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        const containers = nodes.slice(0, i).filter(other =>
          other.path.bounds.contains(node.path.bounds) &&
          other.path.contains(node.path.interiorPoint) &&
          other.path.getIntersections(node.path).length === 0);
        const parent = containers.sort((a, b) => a.area - b.area)[0];
        node.winding = (parent ? parent.winding : 0) + node.sign;
        node.root = parent ? parent.root : node;
        if (!parent) { node.group = new paper.CompoundPath({ insert: false }); roots.push(node); }
        if (!parent || Boolean(parent.winding) !== Boolean(node.winding)) {
          const contour = node.path.clone({ insert: false });
          contour.clockwise = node.winding !== 0;
          node.root.group.addChild(contour);
        }
      }
      let res = null;
      for (const root of roots) {
        root.group.fillRule = 'nonzero';
        if (!res) res = root.group;
        else {
          const next = res.unite(root.group, { insert: false });
          res.remove(); root.group.remove(); res = next;
        }
      }
      const out = res && res.pathData;
      cp.remove(); if (res) res.remove();
      if (!out) throw new Error('No cutting paths were produced.'); return out;
    } catch (e) { throw new Error('Could not merge the cutting paths: ' + e.message); }
  }

  function iconKey(platform, num) { return String(platform).toUpperCase() + String(num); }

  /**
   * item: {username, font, platform, icon, secondPlatform?, secondIcon?, thirdPlatform?, thirdIcon?, size, qty,
   *   upper, iconSizeStep?, spacingStep?, iconYOffsetMm?, or legacy spacing and height adjustments}
   * returns {ok, warnings[], svg, d, filename, ...}
   */
  function build(item, opts = {}) {
    const warnings = [];
    const SPEC = { ...window.SSDecal.SPEC, ...(opts.spec || {}) };
    const sizeKey = (item.size || 'M').toUpperCase();
    const baseIconRatio = SPEC.sizes[sizeKey];
    if (!baseIconRatio) return { ok: false, error: 'Unknown size "' + item.size + '"' };
    const iconSizeStep = item.iconSizeStep == null ? null : Number(item.iconSizeStep);
    if (iconSizeStep !== null && (!Number.isInteger(iconSizeStep) || Math.abs(iconSizeStep) > 3)) {
      return { ok: false, error: 'Choose an available icon size.' };
    }
    const spacingStep = Number(item.spacingStep ?? 0);
    const iconYOffsetMm = Number(item.iconYOffsetMm ?? 0);
    if (!Number.isInteger(spacingStep) || spacingStep < -2 || spacingStep > 5 || !Number.isInteger(iconYOffsetMm * 2) || Math.abs(iconYOffsetMm) > 3) {
      return { ok: false, error: 'Choose an available advanced setting.' };
    }
    // One step moves the letters and each icon gap together. Legacy values
    // remain supported so earlier saved designs can still be reconstructed.
    const letterSpacingPercent = Number(item.letterSpacingPercent ?? spacingStep * 2.5);
    const iconGapMm = Number(item.iconGapMm ?? 2 + spacingStep * 0.5);
    const iconHeightAdjustmentPercent = Number(item.iconHeightAdjustmentPercent ?? 0);
    if (![-5, -2.5, 0, 2.5, 5, 7.5, 10, 12.5, 15].includes(letterSpacingPercent) || ![1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5].includes(iconGapMm) || ![-10, -5, 0, 5, 10].includes(iconHeightAdjustmentPercent)) {
      return { ok: false, error: 'Choose an available advanced setting.' };
    }
    const iconRatio = (iconSizeStep === null ? baseIconRatio : 1 + iconSizeStep * 0.1) * (1 + iconHeightAdjustmentPercent / 100);
    const iconGap = iconGapMm * MM;
    const displayText = item.upper ? String(item.username || '').trim().toUpperCase() : String(item.username || '').trim();
    const font = fontForText(item.font, displayText);
    if (!font) return { ok: false, error: 'Font ' + item.font + ' is not loaded. Upload it under Fonts.' };
    const iconChoices = item.noIcon === true ? [] : [{ platform: item.platform, number: item.icon }];
    if (item.secondPlatform) iconChoices.push({ platform: item.secondPlatform, number: item.secondIcon });
    if (item.thirdPlatform) iconChoices.push({ platform: item.thirdPlatform, number: item.thirdIcon });
    const icons = [];
    for (const choice of iconChoices) {
      const platform = PLATFORMS.find(p => p.key === choice.platform);
      if (!platform || !Number.isInteger(choice.number) || choice.number < 1 || choice.number > platform.count) return { ok: false, error: 'Choose an available platform and icon style.' };
      const key = iconKey(choice.platform, choice.number);
      const raw = window.SS_CUSTOM_ICONS?.[key];
      if (!raw) return { ok: false, error: 'No icon "' + key + '"' };
      const bounds = bbox(raw);
      if (!Number.isFinite(bounds.w) || !Number.isFinite(bounds.h) || bounds.w <= 0 || bounds.h <= 0) return { ok: false, error: 'An icon has no usable cutting outline.' };
      icons.push({ raw, bounds });
    }

    let text = String(item.username || '').trim();
    if (!text) return { ok: false, error: 'Username is empty' };
    if (item.upper) text = text.toUpperCase();

    // missing glyphs
    const missing = [...new Set([...text].filter(ch => font.charToGlyphIndex(ch) === 0 && ch !== ' '))];
    if (missing.length) return { ok:false, error:'This font cannot render: ' + missing.join(' ') + '. Choose another font.' };
    if (text.length > 150) return {ok:false,error:'Username is too long.'};

    // Set the icon's ink height relative to the actual lettering height.
    // Fit both paths together so long handles retain that ratio when lettering shrinks.
    let tc;
    try { tc = textCommands(font, text, { kerning: true, letterSpacing: letterSpacingPercent / 100 }, bettyCapitalSpacingPercent(item, text)); }
    catch (error) { return { ok: false, error: error.message }; }
    let tb = bbox(tc);
    if (!Number.isFinite(tb.w) || !Number.isFinite(tb.h) || tb.w <= 0 || tb.h <= 0) return {ok:false,error:'The username has no visible cutting paths.'};
    const availableWidth = SPEC.boxW - SPEC.marginL - SPEC.marginR - iconGap * icons.length;
    const heightLimit = (SPEC.boxH - 2 * SPEC.vClear) / Math.max(1, icons.length ? iconRatio : 1);
    const iconAspectSum = icons.reduce((sum, icon) => sum + icon.bounds.w / icon.bounds.h, 0);
    const widthLimit = availableWidth / (tb.w / tb.h + iconRatio * iconAspectSum);
    const textH = Math.min(SPEC.textH, heightLimit, widthLimit);
    if (!(textH > 0)) return {ok:false,error:'Artwork does not fit inside this template.'};
    const iconH = textH * iconRatio;
    let iconX = SPEC.marginL;
    let iconCmds = [];
    const iconWidths = [];
    for (const icon of icons) {
      const ib = icon.bounds;
      const is = iconH / ib.h;
      const iconW = ib.w * is;
      iconCmds = iconCmds.concat(transform(icon.raw, is, is, iconX - ib.x0 * is, SPEC.boxH / 2 - (ib.y0 + ib.h / 2) * is + iconYOffsetMm * MM));
      iconWidths.push(iconW);
      iconX += iconW + iconGap;
    }
    const k = textH / tb.h;
    tc = transform(tc, k, k, iconX - tb.x0 * k, SPEC.boxH / 2 - (tb.y0 + tb.h / 2) * k);
    tb = bbox(tc);
    const sx = 1;

    // The customer selects the visible artwork size. Production clearance is
    // independent of that size and can differ between Standard and banners.
    const rawBounds = bbox(iconCmds.concat(tc));
    const paddingXmm = opts.productionPaddingXmm ?? 5;
    const paddingYmm = opts.productionPaddingYmm ?? 5;
    const dx = paddingXmm * MM - rawBounds.x0, dy = paddingYmm * MM - rawBounds.y0;
    iconCmds = transform(iconCmds, 1, 1, dx, dy);
    tc = transform(tc, 1, 1, dx, dy);
    let artD;
    try { artD = unite(toD(iconCmds) + toD(tc)); } catch(e) { return {ok:false,error:e.message}; }
    const artworkBounds=bbox(iconCmds.concat(tc));
    const artworkWidthMm = artworkBounds.w / MM, artworkHeightMm = artworkBounds.h / MM;
    const boxWidthMm = Math.round((artworkWidthMm + 2 * paddingXmm) * 1000) / 1000;
    const boxHeightMm = Math.round((artworkHeightMm + 2 * paddingYmm) * 1000) / 1000;
    const W = boxWidthMm * MM, Hb = boxHeightMm * MM;
    const cutD = `M0 0H${f2(W)}V${f2(Hb)}H0Z`;
    const inverse = item.inverse ? ` transform="translate(${f2(W)} 0) scale(-1 1)"` : '';
    const svg = `<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="${f2(W/MM)}mm" height="${f2(Hb/MM)}mm" viewBox="0 0 ${f2(W)} ${f2(Hb)}">\n` +
      `<path id="cut-box" d="${cutD}" fill="none" stroke="#FF0000" stroke-width="${SPEC.cutStroke}"/>\n` +
      `<path id="decal" d="${artD}"${inverse} fill="#000000" fill-rule="nonzero"/>\n</svg>\n`;

    const filename = fileBase(item);
    return {
      ok: true, warnings, svg, artD, cutD, filename, W, H: Hb,
      sourceCommands: iconCmds.concat(tc),
      bounds:artworkBounds, artworkWidthMm, artworkHeightMm,
      boxWidthMm, boxHeightMm, iconWidthMm:(iconWidths[0] || 0)/MM, iconHeightMm:icons.length ? iconH/MM : 0, iconCount:icons.length,
      iconMaxMm:icons.length ? iconH/MM : 0, textWidthMM: tb.w / MM, textHeightMM: tb.h / MM, squeeze: sx,
    };
  }

  function fileBase(item) {
    const u = String(item.username || '').trim().replace(/[\/\\:*?"<>|]/g, '_');
    const q = (+item.qty > 1) ? ' x' + (+item.qty) : '';
    const icons = [item.noIcon ? 'text-only' : `i${item.icon}`, item.secondPlatform && `${String(item.secondPlatform).toLowerCase()}${item.secondIcon}`, item.thirdPlatform && `${String(item.thirdPlatform).toLowerCase()}${item.thirdIcon}`].filter(Boolean).join('+');
    const size = item.iconSizeStep == null ? String(item.size || 'M').toLowerCase() : `size${item.iconSizeStep}`;
    return `${u} (f${item.font} ${icons} ${size})${q}`;
  }

  // Solve the visible size without letting either line or an icon fall below
  // its cutting minimum. Use the upper bound so an exact tier boundary never
  // becomes fractionally undersized after an icon or font change.
  function fitSize(artwork, { axis = 'width', targetMm, headingAt = null }) {
    const measure = scale => headingAt ? headingAt(scale) : {
      ok: true, widthMm: artwork.artworkWidthMm * scale, heightMm: artwork.artworkHeightMm * scale,
    };
    function reach(start, dimension, target) {
      const first = measure(start);
      if (!first?.ok) return NaN;
      if (first[dimension] >= target) return start;
      let lo = start, hi = start;
      for (let i = 0; i < 20; i++) {
        hi *= 2;
        const shape = measure(hi);
        if (!shape?.ok || shape[dimension] >= target) break;
        lo = hi;
      }
      for (let i = 0; i < 55; i++) {
        const mid = (lo + hi) / 2, shape = measure(mid);
        if (shape?.ok && shape[dimension] < target) lo = mid;
        else hi = mid;
      }
      return measure(hi)?.ok ? hi : NaN;
    }
    let minimumScale = Math.max(20 / artwork.textHeightMM,
      artwork.iconCount ? 20 / artwork.iconHeightMm : 0);
    minimumScale = reach(minimumScale, 'widthMm', headingAt ? 300 : 40);
    const minimum = measure(minimumScale);
    if (!minimum?.ok || !Number.isFinite(minimumScale)) return { ok: false };
    const dimension = axis === 'height' ? 'heightMm' : 'widthMm';
    const clamped = targetMm < minimum[dimension] - 0.000001;
    // A clamped input is shown to two decimal cm places, rounded upwards.
    const effectiveMm = clamped ? Math.ceil((minimum[dimension] - 1e-8) * 10) / 10 : targetMm;
    const scale = reach(minimumScale, dimension, effectiveMm);
    const shape = measure(scale);
    return { ok: Boolean(shape?.ok && Number.isFinite(scale)), scale, minimum,
      clamped, targetMm: effectiveMm, shape };
  }

  window.SSDecal = { SPEC, FONTS, PLATFORMS, MM, build, fitSize, getFont, fontForText, registerFont, bettyCapitalSpacingPercent, iconKey, fileBase, bbox, toD, transform, cmdsFromOT, unite };
})();
